<template>
  <Disclosure v-slot="{ open }" :default-open="inCurrentRoute" v-if="hasPermissionRoute">
    <DisclosureButton
      class="
        flex
        w-full
        px-2
        py-2
        text-sm
        font-medium
        text-white
        rounded-md
        items-center
        relative
      "
    >
        
        <slot name="content"></slot>    
       
      <ChevronLeftIcon
        v-if="menuList"
        :class="open ? 'transform-rotate-90' : ''"
        class="w-5 h-5 right-2 absolute text-white side-menu-arrow"
      />
    </DisclosureButton>
    <DisclosurePanel
        v-if="menuList"
      class="
        menu-list
        ml-4
        dropdown-orange-menu
        mt-1
        px-1
        rounded-md
        py-1
        text-sm text-white
      "
    >
      <slot></slot>
    </DisclosurePanel>
  </Disclosure>
</template>





<script>
import {useRoute} from 'vue-router';
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import helper from "Resources/util/helper";
import SideMenuItem from '@/components/SideBar/SideMenuItem.vue'; // Using the alias




import {
  ChevronLeftIcon
} from "@heroicons/vue/outline";


export default {
  name: "SideMenu",

  props: {
      menuList: {
          default: false,
          type: Boolean,
          required: false
      },
      routeList: {
          default: [],
          type: Array,
          required: true
      }
  },

  components: {
    ChevronLeftIcon,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    SideMenuItem

  },

  setup(props) {

    const route=useRoute();
    
    let list = props.routeList.filter((r) => r.name == route.name);

    const inCurrentRoute = list.length > 0;

    const hasPermissionRoute = helper.permissionCheckOverRouteList(props.routeList.map(r => r.name));
    
    return {
      inCurrentRoute,
      hasPermissionRoute
    };
  },
};
</script>